var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['general-info', _vm.customClass || 'col-12 col-sm-6 col-md-4 col-xl-2']},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('p',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }